var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.24 9.25H2C1.59 9.25 1.25 8.91 1.25 8.5C1.25 8.09 1.59 7.75 2 7.75H15.24C15.65 7.75 15.99 8.09 15.99 8.5C15.99 8.91 15.65 9.25 15.24 9.25Z",
    fill: "#7E92A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29 17.25H6C5.59 17.25 5.25 16.91 5.25 16.5C5.25 16.09 5.59 15.75 6 15.75H7.29C7.7 15.75 8.04 16.09 8.04 16.5C8.04 16.91 7.71 17.25 7.29 17.25Z",
    fill: "#7E92A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.25H11C10.59 17.25 10.25 16.91 10.25 16.5C10.25 16.09 10.59 15.75 11 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z",
    fill: "#7E92A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.56 21.2496H7.97998C7.56998 21.2496 7.22998 20.9096 7.22998 20.4996C7.22998 20.0896 7.56998 19.7496 7.97998 19.7496H17.56C20.7 19.7496 21.25 19.2097 21.25 16.1096V6.88965C21.25 6.47965 21.59 6.13965 22 6.13965C22.41 6.13965 22.75 6.47965 22.75 6.88965V16.0996C22.75 20.0496 21.54 21.2496 17.56 21.2496Z",
    fill: "#7E92A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71 20.89C3.62 20.89 3.52 20.87 3.43 20.84C1.62 20.12 1.25 18.43 1.25 16.11V7.89C1.25 3.95 2.46 2.75 6.44 2.75H17.55C18.69 2.75 19.53 2.84 20.19 3.04C20.59 3.16 20.81 3.57 20.7 3.97C20.58 4.37 20.16 4.59 19.77 4.48C19.25 4.33 18.55 4.26 17.55 4.26H6.44C3.3 4.26 2.75 4.8 2.75 7.9V16.11C2.75 18.5 3.18 19.13 3.99 19.45C4.38 19.6 4.56 20.04 4.41 20.42C4.29 20.71 4.01 20.89 3.71 20.89Z",
    fill: "#7E92A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99994 22.7504C1.80994 22.7504 1.61994 22.6804 1.46994 22.5304C1.17994 22.2404 1.17994 21.7604 1.46994 21.4704L21.4699 1.47043C21.7599 1.18043 22.2399 1.18043 22.5299 1.47043C22.8199 1.76043 22.8199 2.24043 22.5299 2.53043L2.52994 22.5304C2.37994 22.6804 2.18994 22.7504 1.99994 22.7504Z",
    fill: "#7E92A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSlash);
export default __webpack_public_path__ + "static/media/card-slash.31f410da8c0692a5563bfaec198b31c5.svg";
export { ForwardRef as ReactComponent };